var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import Page404 from './404.vue';
var LayoutMain = /** @class */ (function (_super) {
    __extends(LayoutMain, _super);
    function LayoutMain() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fullRoutes = []; // 完整的路由
        return _this;
    }
    Object.defineProperty(LayoutMain.prototype, "keepAlivePages", {
        get: function () {
            return this.$store.state.common.keepAlivePages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutMain.prototype, "routeStatus", {
        // 当前路由状态：200 成功访问，404 无页面
        get: function () {
            return this.fullRoutes.includes(this.$route.path) ? 200 : 404;
        },
        enumerable: false,
        configurable: true
    });
    LayoutMain.prototype.created = function () {
        // 获取完整的路由
        this.fullRoutes = this.$router.options.routes.map(function (item) { return item.path; });
    };
    LayoutMain = __decorate([
        Component({
            components: { Page404: Page404 },
        })
    ], LayoutMain);
    return LayoutMain;
}(Vue));
export default LayoutMain;
